import React, { useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules } from '@utils';
import { useNavigate } from '@utils/hooks';

import { useStore, walletActions } from '@modules';

import BalanceChart from '@containers/BalanceChart';
import LoaderLayout from '@layouts/LoaderLayout';
import MainLayout from '@layouts/MainLayout';

import style from './ProfileOverview.scss';

const cn = bemCssModules(style, 'ProfileOverview');

const ProfileOverview: CustomFC = ({ className }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [{ wallet }, dispatch] = useStore();

  useEffect(() => {
    dispatch(walletActions.getWallet());
  }, []);

  const isLoading = wallet.loaders.getWallet && !wallet.data;

  const onBack = () => navigate(CONST.nav.profile);

  return (
    <MainLayout className={cn(null, [className])} backButton={onBack}>
      <LoaderLayout isLoading={isLoading}>
        <h1 className={cn(['h1'])}>{t('profile.wallets_overview')}</h1>
        <div className={cn('content')}>
          <BalanceChart className={cn('chart')} captionsClass={cn('captions')} isOverview />
        </div>
      </LoaderLayout>
    </MainLayout>
  );
};

export default ProfileOverview;
